import {cn} from '@tempmee/core'
import {forwardRef} from 'react'
import {Flex, type FlexProps} from './Flex'

export {Box, type BoxProps} from './Box'
export {Flex, type FlexProps} from './Flex'
export {Grid, type GridProps} from './Grid'
export type {SpacingScale} from './Variants'

export const Row = forwardRef<HTMLDivElement, FlexProps>((props, ref) => (
  <Flex direction="row" ref={ref} {...props} />
))
Row.displayName = 'Row'

export const Column = forwardRef<HTMLDivElement, FlexProps>((props, ref) => (
  <Flex direction="column" ref={ref} {...props} />
))
Column.displayName = 'Column'

export const Center = forwardRef<HTMLDivElement, FlexProps>((props, ref) => (
  <Flex align="center" justify="center" ref={ref} {...props} />
))
Center.displayName = 'Center'

export const Expanded = forwardRef<HTMLDivElement, FlexProps>(({className, ...props}, ref) => (
  <Flex className={cn('flex-1', className)} ref={ref} {...props} />
))
Expanded.displayName = 'Expanded'
